import {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import "./Printer.scss";
import Table from "../../../Components/Table/Table";
import CustomToolbar from "../../../Components/Table/components/CustomToolbar";
import ButtonField from "../../../Components/Button/ButtonField";
import { Columns } from "../../../Components/Table/ITable";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { useAppDispatch, useAppSelector } from "../../../Redux/Store/Hooks";
import Dialog from "../../../Components/Dialog/Dialog";
import ResponseDialog from "../../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../../Assets/Images/RefreshButton.svg";

// Printer Form
import PrinterForm from "./PrinterForm";
import { IPrinter } from "./IPrinter";
import { printerMasterRead } from "../../../Redux/Slices/Booklet/Admin/PrinterMaster/PrinterMasterRead";
import {
  clearPrinterCreate_Update,
  printerCreate_Update,
} from "../../../Redux/Slices/Booklet/Admin/PrinterMaster/PrinterMasterCreate_Update";

interface PrinterProps {}

const Printer: FunctionComponent<PrinterProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IPrinter | {}>({
    status: true,
  });
 


  const dispatch = useAppDispatch();
  const { data: listPrintersData } = useAppSelector(
    (state) => state.PrinterMasterReadSlice
  );
  const { data: addOrUpdatePrinter } = useAppSelector(
    (state) => state.PrinterCreate_UpdateSlice
  );

  const formRef = useRef<HTMLFormElement>(null);

  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    // {
    //   field: "printer_id",
    //   renderHeader: () => <b>Printer ID</b>,
    //   flex: 1,
    //   type: "string",
    //   headerAlign: "left",
    // },
    {
      field: "printer_name",
      renderHeader: () => <b>Printer Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "model",
      renderHeader: () => <b>Model</b>,
      flex: 1,
      type: "string",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "center",
      align: "center",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,
      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IPrinter>) => {
        return (
          <>
            <IconButtonField
              onClick={() => {
                console.log("Edit clicked for", params.row);
                setInitialValues({ ...params.row });
                setDialogOpen(true);
              }}
              disabled={dialogOpen}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              onClick={() => {
                dispatch(clearPrinterCreate_Update());
                setDeleteData(params.row); 
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  // 🔑 FIX: ensure DataGrid has `id`
  const Printers = Array.isArray(listPrintersData?.data)
    ? listPrintersData?.data.map((printer, index) => ({
        ...printer,
        id: printer.printer_id, // DataGrid requires unique `id`
        index: index + 1,
      }))
    : [];

  useEffect(() => {
    dispatch(printerMasterRead()); // pass {} since it expects payload
  }, [addOrUpdatePrinter, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearPrinterCreate_Update());
    };
  }, []);

  return (
    <>
      <Table rows={Printers ?? []} columns={columns}>
        <CustomToolbar>
          <h6>Printer</h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setDialogOpen(true);
            }}
            disabled={dialogOpen}
            toolTip="Add new"
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(printerMasterRead())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${
          (initialValues as IPrinter).printer_id ? "Update" : "Add"
        } Printer`}
        Dialog_Content={
          <PrinterForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />

      <ResponseDialog
        okFunction={() => setDialogOpen(false)}
        response={addOrUpdatePrinter}
        parentDialog={setDialogOpen}
      />

      {(deleteDialogData && deleteDialogOpen )&& (
        <DeleteDialog

          deleteableName={deleteDialogData.name ?? ""}
          open={deleteDialogOpen}
          setOpen={setDeleteDialogOpen}
          deleteFunction={() => {
            if (deleteDialogData.id) {
              dispatch(
                printerCreate_Update({
                  ...deleteDialogData,
                  is_delete: true,
                })
              );
            }
          }}
          response={addOrUpdatePrinter}
        />
      )}
    </>
  );
};

export default Printer;
